import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import 'reactflow/dist/style.css';
import './fonts.css';

import App from './App';
import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import { ApiProvider } from './contexts/ApiContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { SoftphoneProvider } from './contexts/SoftphoneContext';
import { AgentProvider } from './contexts/AgentContext';

if (typeof window !== 'undefined') {
  const frontendTrace = {
    app: 'enigmapbx',
    mode: process.env.NODE_ENV,
    loadedAt: new Date().toISOString()
  };
  window.__FRONTEND_TRACE = frontendTrace;
  console.warn('[FRONTEND TRACE] index.js loaded', frontendTrace);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <ApiProvider>
            <NotificationProvider>
              <AgentProvider>
                <SoftphoneProvider>
                  <App />
                </SoftphoneProvider>
              </AgentProvider>
            </NotificationProvider>
          </ApiProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
